import { useToggleModalState } from '@/shared/hooks/useToggleModalState';

import { MARKETING_MODALS } from '~/marketing/constants/modals';

export const useDiscountRequestModal = () => {
  return useToggleModalState({
    name: MARKETING_MODALS.DISCOUNT_REQUEST,
  });
};

